// @ts-ignore
import Cookies from 'js-cookies';

const AuthService = {
  login: async (targetPhone?: string) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    try {
      const response = await fetch(`${baseUrl}/api/auth/redirect-login`);
      if (response.ok) {
        window.location.href = response.url;
      } else {
        const loginUrlResponse = await fetch(`${baseUrl}/api/auth/login-url`);
        if (loginUrlResponse.ok) {
          const data = await loginUrlResponse.json();
          window.location.href = data.loginUrl;
        } else {
          window.location.href = process.env.REACT_APP_AWS_START_URL || "";
        }
      }
    } catch (error) {
      window.location.href = process.env.REACT_APP_AWS_START_URL || "";
    }
  },

  logout: async () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    Cookies.removeItem("token");
    Cookies.removeItem("departamento");
    Cookies.removeItem("user");
    Cookies.removeItem("userType");
    Cookies.removeItem("phoneNumber");
    Cookies.removeItem("allowedPhones");
    Cookies.removeItem("hasFullAccess");

    try {
      const response = await fetch(`${baseUrl}/api/auth/logout`);
      if (response.ok) {
        window.location.href = response.url;
      } else {
        const startUrlResponse = await fetch(`${baseUrl}/api/auth/start-url`);
        if (startUrlResponse.ok) {
          const data = await startUrlResponse.json();
          window.location.href = data.startUrl;
        } else {
          window.location.href = process.env.REACT_APP_AWS_START_URL || "";
        }
      }
    } catch (error) {
      window.location.href = process.env.REACT_APP_AWS_START_URL || "";
    }
  },

  getStartUrl: async () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    try {
      const response = await fetch(`${baseUrl}/api/auth/start-url`);
      if (response.ok) {
        const data = await response.json();
        return data.startUrl;
      }
    } catch (error) {
      console.error('Error getting start URL:', error);
    }
    return process.env.REACT_APP_AWS_START_URL || "";
  }
};

export default AuthService;
